import { ContactService } from "../services/contacts.service";
import { Injectable } from '@angular/core';
import { of, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContactGroup } from "../../admin/models/contactGroup.model";
import { LoaderService } from '../../common/services/loader.service';


@Injectable()
export class ManageContactsResolver  {
  constructor(public dataService: ContactService,
              public loaderService: LoaderService) {
  }

  resolve(route: ActivatedRouteSnapshot) {    
      this.loaderService.toggleLoader(true);
      let obs$: Observable<ContactGroup>;
      if (route.paramMap.get('id')) {
          obs$ = this.dataService.getContactGroup(route.paramMap.get('id'), true);
          } else {
          obs$ = of(null);
      }
      return obs$.pipe(tap((data) => {
          this.loaderService.toggleLoader(false);
      }));
  }
}